/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Plugin, PluginKey } from "@tiptap/pm/state";
import { find } from "linkifyjs";

export const pasteHandler = (options) => {
    return new Plugin({
        key: new PluginKey("handlePasteLink"),
        props: {
            handlePaste: (view, event, slice) => {
                const state = view?.state;
                const selection = state?.selection;
                const empty = selection?.empty;

                if (empty) {
                    return false;
                }

                let textContent = "";

                slice.content.forEach((node) => {
                    textContent += node.textContent;
                });
                
                // use Linkify find
                const link = find(textContent, { defaultProtocol: options.defaultProtocol })
                    .find((item) => item.isLink && item.value === textContent);

                if (!textContent || !link) {
                    return false;
                }

                return options.editor.commands.setMark(options.type, {
                    href: link.href,
                });
            },
        },
    });
};
